import { render, staticRenderFns } from "./InstagramMockupPreview.vue?vue&type=template&id=197fc045&scoped=true&"
import script from "./InstagramMockupPreview.vue?vue&type=script&lang=js&"
export * from "./InstagramMockupPreview.vue?vue&type=script&lang=js&"
import style0 from "./InstagramMockupPreview.vue?vue&type=style&index=0&id=197fc045&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197fc045",
  null
  
)

export default component.exports